import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DadosOndeAlterarAutorizacao {
  // "Módulo / Tela - Funcionalidade", como aparece na grade do grupo de permissão
  funcionalidade: string;
}

// Pop-up de ajuda do modal "Autorizar acesso": diz onde alterar a ação da funcionalidade que abriu o modal
@Component({
  selector: 'app-dialog-onde-alterar-autorizacao',
  templateUrl: './dialog-onde-alterar-autorizacao.component.html',
  styleUrls: ['./dialog-onde-alterar-autorizacao.component.scss']
})
export class DialogOndeAlterarAutorizacaoComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DadosOndeAlterarAutorizacao) { }
}
